import Vue from 'vue';
import Router from 'vue-router';
import { auth } from './firebaseConfig';
import { i18n } from './plugins/i18n';
import EmployeeHome from './views/employee/EmployeeHome.vue';
import EmployeeRegistration from './views/employee/EmployeeRegistration.vue';
import EmployeeSchedule from './views/employee/EmployeeSchedule.vue';
import EmployeeSkills from './views/employee/EmployeeSkills.vue';
import EmployeeList from './views/employer/EmployeeList.vue';
import EmployerHome from './views/employer/EmployerHome.vue';
import EmployerRegistration from './views/employer/EmployerRegistration.vue';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import Register from './views/Register.vue';
import Settings from './views/Settings.vue';
import TaskList from './views/task/TaskList.vue';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:lang?',
      name: 'home',
      component: Home,
      beforeEnter: (to, from, next) => {
        const lang = to.params.lang;
        if (!lang || !['id', 'en'].includes(lang)) {
          return next(`en${to.path}`);
        }
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      },
      children: [
        {
          path: 'login',
          name: 'login',
          component: Login
        },
        {
          path: 'loginas',
          name: 'loginas',
          component: Register
        },
        {
          path: 'employeeRegistration',
          name: 'employeeRegistration',
          component: EmployeeRegistration
        },
        {
          path: 'employeeHome',
          name: 'employeeHome',
          component: EmployeeHome
        },
        {
          path: 'employeeSkills',
          name: 'employeeSkills',
          component: EmployeeSkills
        },
        {
          path: 'employeeSchedule',
          name: 'employeeSchedule',
          component: EmployeeSchedule
        },
        {
          path: 'employeeList',
          name: 'employeeList',
          component: EmployeeList,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'employerHome',
          name: 'employerHome',
          component: EmployerHome
        },
        {
          path: 'employerRegistration',
          name: 'employerRegistration',
          component: EmployerRegistration
        },
        {
          path: 'task',
          name: 'task',
          component: TaskList,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'settings',
          name: 'settings',
          component: Settings
        }
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () =>
        //   import(/* webpackChunkName: "about" */ './views/employee/EmployeeList.vue')
      ]
    }
    // {
    //   path: '*',
    //   redirect: '/home'
    // }
  ]
});
router.beforeEach((to, from, next) => {
  const currentUser = auth.currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) {
    return next('login');
  } else {
    next();
  }
});

export default router;
